<div class="container-xl">
    <div class="row justify-content-between">
        <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
        @if (form()?.get('id').value) {
            <button (click)="deleteUser($event)" class="icon-button-medium" color="warn" mat-icon-button>
                <mat-icon fontIcon="fa-trash" fontSet="fas"></mat-icon>
            </button>
        }
    </div>

    @if (form()) {
        <form [formGroup]="form()" class="row gap-3" id="user-form">
            <div class="col-12">
                <div class="row">
                    <div class="col-auto">
                        <b>Naam</b>
                        <div>
                            <mat-form-field class="w-100" id="name">
                                <input
                                    formControlName="name"
                                    matInput
                                    name="name"
                                    placeholder="Naam"
                                    type="text">
                                <mat-error>Dit veld moet minimaal 3 tekens bevatten</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>E-mailadres</b>
                        <div>
                            <mat-form-field class="w-100" id="email">
                                <input
                                    formControlName="email"
                                    matInput
                                    name="email"
                                    placeholder="E-mailadres"
                                    type="email">
                                <mat-error>Vul een correct e-mailadres in</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <b>Rollen</b>
                    <div class="row">
                        <ng-select [items]="roles" [multiple]="true" [searchable]="true" bindLabel="name" bindValue="key" formControlName="roles">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <b>Tarief per uur</b>
                <div>
                    <mat-form-field class="w-100" id="hourly_rate">
                        <input
                            formControlName="hourly_rate"
                            matInput
                            name="hourly_rate"
                            placeholder="Tarief per uur"
                            step="0.01"
                            type="number">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-auto">
                <b>Parttime percentage</b>
                <div>
                    <mat-form-field class="w-100" id="part_time_rate">
                        <input
                            formControlName="part_time_rate"
                            matInput
                            max="100"
                            min="0"
                            name="part_time_rate"
                            placeholder="Parttime percentage"
                            type="number">
                    </mat-form-field>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-auto">
                        <b>Begin werkzaamheden</b>
                        <div>
                            <mat-form-field>
                                <input
                                    (focus)="pickerStart.open()"
                                    [matDatepicker]="pickerStart"
                                    [min]="minDate"
                                    formControlName="employment_start"
                                    matInput
                                    placeholder="Begin werkzaamheden">
                                <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #pickerStart></mat-datepicker>
                                <mat-error [control]="form().get('employment_start')"></mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-auto">
                        <b>Einde werkzaamheden</b>
                        <div>
                            <mat-form-field>
                                <input
                                    (focus)="pickerEnd.open()"
                                    [matDatepicker]="pickerEnd"
                                    [min]="minDate"
                                    formControlName="employment_end"
                                    matInput
                                    placeholder="Einde werkzaamheden">
                                <mat-datepicker-toggle [for]="pickerEnd" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #pickerEnd></mat-datepicker>
                                <mat-error [control]="form().get('employment_end')"></mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <b>Periodieke kosten</b>
                <div>
                    <mat-form-field class="w-100" id="period_costs">
                        <input
                            formControlName="period_costs"
                            matInput
                            name="period_costs"
                            placeholder="Periodieke kosten"
                            type="text">
                    </mat-form-field>
                </div>
            </div>
        </form>

        <button
            (click)="save()"
            [disabled]="form()?.invalid || saving"
            class="btn btn-primary"
            form="user-form"
            id="btn-save">
            Opslaan
            @if (saving) {
                <i class="fas fa-circle-notch fa-spin ml-2"></i>
            }
        </button>
    }
</div>
